/**
 * Palette hook: "Chart: Change layout…" opens the picker of the chart module used last. Kept out
 * of ChartPanel.tsx so the command registry (entry chunk) does not import the chart chunk.
 */

export type Registered = { open: () => void };
const mounted: Registered[] = [];

/** Mark a chart module as the most recently used one (registers it when new). */
export function touch(r: Registered): void {
  untouch(r);
  mounted.push(r);
}

/** Forget a chart module (unmount). */
export function untouch(r: Registered): void {
  const i = mounted.indexOf(r);
  if (i >= 0) mounted.splice(i, 1);
}

/** Chart modules currently mounted (palette `when`). */
export function chartModuleCount(): number {
  return mounted.length;
}

/** Open the layout picker of the most recently used chart module; false when there is none. */
export function openChartLayoutPicker(): boolean {
  const r = mounted.at(-1);
  if (!r) return false;
  r.open();
  return true;
}
